import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from './img/logo.png'
import { checkDeviceIOS } from '../../utils'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'plena';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-plena-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-plena rounded mx-auto d-block" />
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="plena-form-container">
            <Row className="plena-form-header">
              <h3>Acesse com o seu login e senha da sua operadora de internet</h3>
            </Row>
            <Row className="plena-form-body">
              <Col sm="12" xs="12" md="12" className="plena-input">
                <Input
                  className="user-input-plena"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeHolder="LOGIN"
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="plena-input">
                <Input
                  className="pass-input-plena"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeHolder="SENHA"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
            </Row>
            <small>
              <a href="mailto:contato@seuplay.com.br?subject=Esqueci minha senha" className="plena-forget-pass">
                Esqueci minha senha
              </a>
            </small>
            {!onLogin ? (
              <button
                block={!parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                id="submmit"
                className="enter-plena"
                disabled={!props.turnstileSuccess}
              >
                {translate("ButtonEnter")}
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            {
              checkDeviceIOS() ? '' : <p className="plena-btn-register">
                <a href="mailto:contato@seuplay.com.br?subject=Não tenho cadastro" >
                  Ainda não tenho cadastro
                </a>
              </p>
            }

            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm);
